// extracted by mini-css-extract-plugin
export default {"link":"HeadPage_link__EVVxK","lastLink":"HeadPage_lastLink__armnE"};